import { breakpoints } from './breakpoints';

// Helpers para interpolar dentro de styled-components:
//
//   import { up } from '../../styles/media';
//
//   export const Box = styled.div`
//     padding: 1rem;
//     ${up('md')} { padding: 2rem; }
//   `;
//
// O -0.02px evita sobreposição com up() em viewports fracionários (zoom).
export const up = (key) => `@media (min-width: ${breakpoints[key]}px)`;

export const down = (key) => `@media (max-width: ${breakpoints[key] - 0.02}px)`;

export const between = (from, to) =>
  `@media (min-width: ${breakpoints[from]}px) and (max-width: ${
    breakpoints[to] - 0.02
  }px)`;
